import { createContext } from 'react'

interface SidebarContextType {
  isCollapsed: boolean
  isMobileOpen: boolean
  openItems: string[]
  toggleCollapse: () => void
  toggleMobile: () => void
  toggleItem: (itemId: string) => void
  setMobileOpen: (open: boolean) => void
}

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined)
